import { useEffect, useLayoutEffect } from 'react';

import { useLocation } from 'react-router';

import { scrollToTop } from '@/lib/scrollToTop';

export const RouterScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    return scrollToTop();
  }, [pathname]);

  return null;
};
